import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useMemo, useState } from "react";
import { useEmbarqueDependencias } from "../../contexts/EmbarqueDependenciasContext.tsx";
import RequestControllerRedux from "../../contexts/RequestController.js";
import TabelaRedux from "../../contexts/Tabela.js";
import CustomButtonV2 from "../CustomButtonV2/CustomButtonV2.js";
import ModalCadastro from "../ModalCadastro/ModalCadastro.tsx";
import "../ModalLancarMercadoria/ModalLancarMercadoria.css";
import NewIcon from "../NewIcon/NewIcon.js";
import SelectEmbarqueV2 from "../SelectEmbarqueV2/SelectEmbarqueV2.js";

export interface SimpleDialogProps {
	titulo: string;
	tituloBotao: string;
	tituloConfirmar: string;
	texto: string;
	dataAlteracao: string;
	open: boolean;
	onClose: () => void;
	onClick: () => void;
	setMercadoria: (e) => void;
}

function ModalLancarMercadoria(props: SimpleDialogProps) {
	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const { mercadoria: listaMercadoria } = useEmbarqueDependencias();

	const { tabelaRedux } = useContext(TabelaRedux);

	const { onClose, open, onClick } = props;

	const [valuesSelect, setValuesSelect] = useState<any>([]);

	const handleClose = () => {
		onClose();
		if (mercadoriaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				mercadoria: {
					value: mercadoriaSelecionado.nome,
					label: mercadoriaSelecionado.nome,
					id: mercadoriaSelecionado.idMercadoria,
				},
			}));
			props.setMercadoria(mercadoriaSelecionado.idMercadoria);
		}
	};

	const handleClick = () => {
		onClick();
	};

	const clearMercadoria = () => {
		setValuesSelect((current) => ({ ...current, mercadoria: "" }));
	};

	const [idAtual, setIdAtual] = useState(0);

	const [disable, setDisable] = useState(false);

	const [openCadastroMercadoria, setOpenCadastroMercadoria] = useState(false);

	const mercadoriaSelecionado = useMemo(() => {
		return listaMercadoria.find(
			(option) => option.nome === tabelaRedux?.row?.mercadoria
		);
	}, [listaMercadoria, tabelaRedux?.row?.mercadoria]);

	useEffect(() => {
		if (mercadoriaSelecionado) {
			setValuesSelect((current) => ({
				...current,
				mercadoria: {
					value: mercadoriaSelecionado.nome,
					label: mercadoriaSelecionado.nome,
					id: mercadoriaSelecionado.idMercadoria,
				},
			}));
			props.setMercadoria(mercadoriaSelecionado.idMercadoria);
		}
	}, [tabelaRedux]);

	const handleCloseCadastroMercadoria = () => {
		if (idAtual) {
			setOpenCadastroMercadoria(false);
			setDadosRequestControllerRedux("Close Mercadoria");
		} else {
			setDadosRequestControllerRedux("Close Mercadoria");
			setOpenCadastroMercadoria(false);
		}
	};

	return (
		<div>
			<Dialog open={open} onClose={handleClose}>
				<div className="div-modal-usuario">
					<DialogTitle id="alert-dialog-title">{props.titulo}</DialogTitle>
					<DialogContent className="content-veiculo">
						<div className="usuario-data-row">
							<div className="coluna-modalmotivo">
								<div>
									<p className="input-label-emb">Mercadoria:</p>
									<SelectEmbarqueV2
										classeCss={225}
										onChange={(e) => {
											setValuesSelect((current) => ({
												...current,
												mercadoria: e,
											}));
											props.setMercadoria(e.id);
										}}
										clearSelection={clearMercadoria}
										onInfoIconClick={setIdAtual}
										pequeno={true}
										id="idMercadoria"
										value={valuesSelect.mercadoria}
										titulo="Mercadoria"
										dadosSelect={listaMercadoria}
										referenciaId="nome"
										referenciaItem="nome"
									/>
								</div>
								<NewIcon
									onClick={(e) => {
										setOpenCadastroMercadoria(true);
										setIdAtual(0);
										setDisable(false);
									}}
								/>
							</div>
						</div>
					</DialogContent>
					<DialogActions>
						<CustomButtonV2
							classCss="custom-button-cadastrar"
							classText="button-texto-cadastrar"
							titulo="OK"
							cor="#0946B8"
							onClick={handleClick}
						/>
						<CustomButtonV2
							classCss="custom-button-cancelar"
							classText="button-texto-cancelar"
							titulo="Cancelar"
							cor="#0946B8"
							onClick={handleClose}
						/>
					</DialogActions>
				</div>
			</Dialog>
			<div>
				<ModalCadastro
					titulo="Cadastro"
					tituloConfirmar="OK"
					cadastroMercadoria="sim"
					open={openCadastroMercadoria}
					idAtual={idAtual}
					desabilitar={disable}
					onClose={handleCloseCadastroMercadoria}
				/>
			</div>
		</div>
	);
}

export default ModalLancarMercadoria;
